(ns ycweb.components.scroll)

(def speed 350)
(def moving-frequency 5)

(defn cur-doc-top []
  #?(:cljs
     (+
       (.. js/document -body -scrollTop)
       (.. js/document -documentElement -scrollTop))
     :clj 0))

(defn element-top [elem top]
  #?(:cljs
     (if (.-offsetParent elem)
       (let [client-top (or (.-clientTop elem) 0)
             offset-top (.-offsetTop elem)]
         (+ top client-top offset-top (element-top (.-offsetParent elem) top)))
       top)
     :clj 0))

(defn get-elem-pos [elem-id]
  #?(:cljs
     (let [elem (.getElementById js/document elem-id)]
       (when elem
         (element-top elem 0)))
     :clj nil))

(defn scroll-to-id
  [e elem-id]
  #?(:cljs
     (do
       (when e
         (.preventDefault e))
       (let [elem (.getElementById js/document elem-id)]
         (when elem
           (let [hop-count (/ speed moving-frequency)
                 doc-top (cur-doc-top)
                 gap (/ (- (element-top elem -24) doc-top) hop-count)]
             (doseq [i (range 1 (inc hop-count))]
               (let [hop-top-pos (* gap i)
                     move-to (+ hop-top-pos doc-top)
                     timeout (* moving-frequency i)]
                 (.setTimeout js/window
                   (fn []
                     (.scrollTo js/window 0 move-to))
                   timeout)))))))))



